import React from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import defaultProfile from "../../assets/default-profile.jpg";

import {
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";

import { connect } from "react-redux";
import { logout } from "../../../store/common/actions";
import { isEmpty } from "lodash";
import { useRequiredAuth } from "../../common/guard/requiredAuth";

const Drawer = (props) => {
  const {
    drawerState,
    setDrawerState,
    user,
    logout,
    selectedModule,
    userProfilePicture,
    env,
  } = props;

  const location = useLocation();
  const history = useHistory();
  const { hasPermissions } = useRequiredAuth();
  return (
    <React.Fragment>
      <div
        id="drawer"
        className={`position-fixed  ${drawerState ? "active" : ""}`}
      >
        <div>
          <div
            className="drawer-user "
            style={{ borderBottom: "1px solid #d8d9da" }}
          >
            {userProfilePicture && (
              <img
                src={`data:image/png;base64,${userProfilePicture}`}
                className="img-fluid rounded-circle mb-2"
                alt="Linda Miller"
              />
            )}
            {!userProfilePicture && (
              <img
                src={defaultProfile}
                className="img-fluid rounded-circle mb-2"
                alt="Linda Miller"
              />
            )}
            <div>
              <Tooltip title="Go to your profile">
                <Link
                  to="/structure/profile"
                  style={{ color: "#b8ff07" }}
                  className="font-weight-bold text-uppercase"
                  onClick={() => {
                    setDrawerState(false);
                  }}
                >
                  {user.firstName} {user.lastName}
                </Link>
              </Tooltip>
            </div>
            {user.employments.map((employment, index) => (
              <small className=" " style={{ color: "#ff0" }} key={index}>
                {employment.positionName}
              </small>
            ))}
            <br />
            <small style={{ color: "#fff" }}>
              <>
                {!isEmpty(user) &&
                  !isEmpty(user.selectedEntitySector) &&
                  !isEmpty(selectedModule) && (
                    <>
                      {user.selectedEntitySector.roles[selectedModule.id]
                        ?.length > 0 && (
                        <>
                          {user.selectedEntitySector.roles[
                            selectedModule.id
                          ]?.map((role, index) => (
                            <span key={index}>
                              {" "}
                              {role.name}
                              {user.selectedEntitySector.roles[
                                selectedModule.id
                              ].length !==
                                index + 1 && <>,</>}
                            </span>
                          ))}
                        </>
                      )}

                      {user.selectedEntitySector.roles[selectedModule.id]
                        ?.length === 0 && <>Employee</>}
                    </>
                  )}
              </>
            </small>
          </div>
          <div style={{ marginTop: "0px" }}>
            <div style={{ backgroundColor: "#e5cb05", height: "2px" }}></div>
            <div style={{ backgroundColor: "#199e05", height: "2px" }}></div>
          </div>
          <List>
            {hasPermissions(["IS_HR", "IS_DAF", "IS_CBM"]) && (
              <>
                <ListItem
                  disablePadding
                  className={`nav-item  ${
                    location.pathname.includes("/recruitment/requisitions")
                      ? "active"
                      : ""
                  }`}
                  onClick={() => {
                    setDrawerState(false);
                  }}
                >
                  <ListItemButton>
                    <ListItemIcon className="item-icon text-dark">
                      <span className="material-icons">lists</span>
                    </ListItemIcon>
                    <Link to="/recruitment/requisitions" className="text-dark">
                      <ListItemText
                        primary="Requisitions"
                        className="pl-0"
                      ></ListItemText>
                    </Link>
                  </ListItemButton>
                </ListItem>
              </>
            )}

            {hasPermissions([
              "IS_HR",
              "IS_DAF",
              "IS_CBM",
              "IS_RECRUITMENT_MEMBER",
            ]) && (
              <>
                <ListItem
                  disablePadding
                  className={`nav-item  ${
                    location.pathname.includes("/recruitment/advertisements")
                      ? "active"
                      : ""
                  }`}
                  onClick={() => {
                    setDrawerState(false);
                  }}
                >
                  <ListItemButton>
                    <ListItemIcon className="item-icon text-dark">
                      <span className="material-icons">lists</span>
                    </ListItemIcon>
                    <Link
                      to="/recruitment/advertisements"
                      className="text-dark"
                    >
                      <ListItemText
                        primary="Advertisements"
                        className="pl-0"
                      ></ListItemText>
                    </Link>
                  </ListItemButton>
                </ListItem>
              </>
            )}

            {hasPermissions([
              "IS_HR",
              "IS_DAF",
              "IS_CBM",
              "IS_NPSC_APPROVER",
              "IS_NPSC",
              "IS_RECRUITMENT_MEMBER",
            ]) && (
              <>
                <ListItem
                  disablePadding
                  className={`nav-item  ${
                    location.pathname.includes("/recruitment/appeals")
                      ? "active"
                      : ""
                  }`}
                  onClick={() => {
                    setDrawerState(false);
                  }}
                >
                  <ListItemButton>
                    <ListItemIcon className="item-icon text-dark">
                      <span className="material-icons">lists</span>
                    </ListItemIcon>
                    <Link to="/recruitment/appeals" className="text-dark">
                      <ListItemText
                        primary="Appeals"
                        className="pl-0"
                      ></ListItemText>
                    </Link>
                  </ListItemButton>
                </ListItem>
              </>
            )}

            {hasPermissions([
              "IS_HR",
              "IS_DAF",
              "IS_CBM",
              "IS_RECRUITMENT_ADMIN",
            ]) && (
              <>
                <ListItem
                  disablePadding
                  className={`nav-item  ${
                    location.pathname.includes("/recruitment/waiting-list")
                      ? "active"
                      : ""
                  }`}
                  onClick={() => {
                    setDrawerState(false);
                  }}
                >
                  <ListItemButton>
                    <ListItemIcon className="item-icon text-dark">
                      <span className="material-icons">lists</span>
                    </ListItemIcon>
                    <Link to="/recruitment/waiting-list" className="text-dark">
                      <ListItemText
                        primary="Waiting Lists"
                        className="pl-0"
                      ></ListItemText>
                    </Link>
                  </ListItemButton>
                </ListItem>
              </>
            )}
            {hasPermissions(["IS_RECRUITMENT_ADMIN"]) && (
              <>
                <ListItem
                  disablePadding
                  className={`nav-item  ${
                    location.pathname.includes("/recruitment/all-disabilities")
                      ? "active"
                      : ""
                  }`}
                  onClick={() => {
                    setDrawerState(false);
                  }}
                >
                  <ListItemButton>
                    <ListItemIcon className="item-icon text-dark">
                      <span className="material-icons">lists</span>
                    </ListItemIcon>
                    <Link
                      to="/recruitment/all-disabilities"
                      className="text-dark"
                    >
                      <ListItemText
                        primary="All disabilities"
                        className="pl-0"
                      ></ListItemText>
                    </Link>
                  </ListItemButton>
                </ListItem>
              </>
            )}
            {hasPermissions(["IS_PANELIST"]) && (
              <>
                <ListItem
                  disablePadding
                  className={`nav-item  ${
                    location.pathname.includes("/recruitment/panels")
                      ? "active"
                      : ""
                  }`}
                  onClick={() => {
                    setDrawerState(false);
                  }}
                >
                  <ListItemButton>
                    <ListItemIcon className="item-icon text-dark">
                      <span className="material-icons">lists</span>
                    </ListItemIcon>
                    <Link to="/recruitment/panels" className="text-dark">
                      <ListItemText
                        primary="Oral Panels"
                        className="pl-0"
                      ></ListItemText>
                    </Link>
                  </ListItemButton>
                </ListItem>
              </>
            )}
            {hasPermissions(["IS_INVIGILATOR"]) && (
              <>
                <ListItem
                  disablePadding
                  className={`nav-item  ${
                    location.pathname.includes("/recruitment/invigilators")
                      ? "active"
                      : ""
                  }`}
                  onClick={() => {
                    setDrawerState(false);
                  }}
                >
                  <ListItemButton>
                    <ListItemIcon className="item-icon text-dark">
                      <span className="material-icons">lists</span>
                    </ListItemIcon>
                    <Link to="/recruitment/invigilators" className="text-dark">
                      <ListItemText
                        primary="Invigilator Exams"
                        className="pl-0"
                      ></ListItemText>
                    </Link>
                  </ListItemButton>
                </ListItem>
              </>
            )}

            {hasPermissions(["IS_NPSC", "IS_RECRUITMENT_ADMIN"]) && (
              <>
                <ListItem
                  disablePadding
                  className={`nav-item  ${
                    location.pathname.includes("/recruitment/oversight")
                      ? "active"
                      : ""
                  }`}
                  onClick={() => {
                    setDrawerState(false);
                  }}
                >
                  <ListItemButton>
                    <ListItemIcon className="item-icon text-dark">
                      <span className="material-icons">lists</span>
                    </ListItemIcon>
                    <Link to="/recruitment/oversight" className="text-dark">
                      <ListItemText
                        primary="Oversight"
                        className="pl-0"
                      ></ListItemText>
                    </Link>
                  </ListItemButton>
                </ListItem>
              </>
            )}
            {hasPermissions([
              "IS_HR",
              "IS_DAF",
              "IS_CBM",
              "IS_HEAD_OF_INSTITUTION",
              "IS_HEAD_OF_INSTITUTION_ACTING",
              "IS_REC_REVIEWER",
            ]) &&
              env !== "prod" && (
                <>
                  <ListItem
                    disablePadding
                    className={`nav-item  ${
                      location.pathname.includes("/recruitment/requests")
                        ? "active"
                        : ""
                    }`}
                    onClick={() => {
                      setDrawerState(false);
                    }}
                  >
                    <ListItemButton>
                      <ListItemIcon className="item-icon text-dark">
                        <span className="material-icons">lists</span>
                      </ListItemIcon>
                      <Link to="/recruitment/requests" className="text-dark">
                        <ListItemText
                          primary="All requests"
                          className="pl-0"
                        ></ListItemText>
                      </Link>
                    </ListItemButton>
                  </ListItem>
                </>
              )}
            {hasPermissions([
              "IS_HR",
              "IS_DAF",
              "IS_CBM",
              "IS_NPSC",
              "IS_NPSC_APPROVER",
              "IS_HEAD_OF_INSTITUTION",
              "IS_HEAD_OF_INSTITUTION_ACTING",
              "IS_REC_REVIEWER",
            ]) && (
              <>
                <ListItem
                  disablePadding
                  className={`nav-item  ${
                    location.pathname.includes("/recruitment/reports")
                      ? "active"
                      : ""
                  }`}
                  onClick={() => {
                    setDrawerState(false);
                  }}
                >
                  <ListItemButton>
                    <ListItemIcon className="item-icon text-dark">
                      <span className="material-icons">lists</span>
                    </ListItemIcon>
                    <Link to="/recruitment/reports" className="text-dark">
                      <ListItemText
                        primary="Report Submitted"
                        className="pl-0"
                      ></ListItemText>
                    </Link>
                  </ListItemButton>
                </ListItem>
              </>
            )}
            {hasPermissions([
              "IS_RECRUITMENT_ADMIN",
              "IS_NPSC",
              "IS_NPSC_APPROVER",
            ]) && (
              <>
                <ListItem
                  disablePadding
                  className={`nav-item  ${
                    location.pathname.includes(
                      "/recruitment/periodical-reports"
                    )
                      ? "active"
                      : ""
                  }`}
                  onClick={() => {
                    setDrawerState(false);
                  }}
                >
                  <ListItemButton>
                    <ListItemIcon className="item-icon text-dark">
                      <span className="material-icons">lists</span>
                    </ListItemIcon>
                    <Link
                      to="/recruitment/periodical-reports"
                      className="text-dark"
                    >
                      <ListItemText
                        primary="Report Submitted"
                        className="pl-0"
                      ></ListItemText>
                    </Link>
                  </ListItemButton>
                </ListItem>
              </>
            )}
          </List>
        </div>
        <Button
          className="btn btn-block mb-3 "
          color="error"
          style={{ position: "absolute", bottom: "0" }}
          onClick={() => logout(history)}
        >
          <i
            className="fas fa-sign-out-alt mr-2 "
            style={{ transform: "rotate(180deg)" }}
          ></i>
          Logout
        </Button>
      </div>

      <div
        id="drawer-void"
        className={`position-fixed ${drawerState ? "d-block" : "d-none"} `}
        onClick={() => {
          setDrawerState(false);
        }}
      ></div>
    </React.Fragment>
  );
};

const mapStateToProps = ({ user, selectedModule, userProfilePicture, env }) => {
  return { user, selectedModule, userProfilePicture, env };
};

export default connect(mapStateToProps, { logout })(Drawer);
